module.exports = __webpack_public_path__ + "img/swap-line-short.bb2934eb.svg";